export enum ContentfulContentTypes {
  Page = 'page',
}
